import React, { useState } from 'react'
import OrderFormParent from '../Orders/OrderFormParent'

const AddOrderModalGlobally = ({ key, visible, onClose, setIsOrderModalVisible }) => {

    const handlePassFunction = () => {
        setIsOrderModalVisible(true)
    }

    return (
        <>
            <OrderFormParent
                visible={visible}
                onClose={onClose}
                setVisible={setIsOrderModalVisible}
                loadOrders={handlePassFunction}
                modalKey={key}
            />
        </>
    )
}

export default AddOrderModalGlobally